/* eslint-disable no-unused-vars */
import axios from 'axios'

export default {
  login: (context, payload) => {
    const { commit } = context
    const url = `${process.env.VUE_APP_BASE_URL}auth/login`

    return new Promise((resolve, reject) => {
      axios.post(url, payload)
        .then(response => {
          const { data } = response

          commit('setUser', data)
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  reconnect: (context, payload) => {
    const { commit } = context
    const url = `${process.env.VUE_APP_BASE_URL}auth/reconnect`

    return new Promise((resolve, reject) => {
      axios.post(url, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  recovery: (_context, payload) => {
    const { commit } = _context
    const url = `${process.env.VUE_APP_BASE_URL}auth/recovery`

    return new Promise((resolve, reject) => {
      axios.post(url, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  reset: (_context, payload) => {
    const { commit } = _context
    const url = `${process.env.VUE_APP_BASE_URL}auth/reset`

    return new Promise((resolve, reject) => {
      axios.post(url, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}
